export default function Brand() {
  return (
    <div className="brand">
      <img className="brand-mark" src="/assets/agentordinary/agents-orb/agents-orb__default.webp" alt="" />
      <div>
        <strong>AgentOrdinary</strong>
        <small>AI WORKFORCE</small>
      </div>
    </div>
  );
}

